import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Button, IconButton, Tooltip, Typography } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Box } from '@mui/system';
import { Close } from '@mui/icons-material';
import { ErrorAlert, SuccessAlert } from '../../utils/Alerts';
import { useDeleteStyleMutation } from '../../Slices/roomNateApis';
import AddStyleModal from './AddStyleModal';
import ViewStyleModal from './ViewStyleModal';
import UpdateStyleModal from './UpdateStyleModal';

export default function BasicTable({ FetchStyles, isLoading }) {

    const [selectedId, setSelectedId] = React.useState()

    const [open, setOpen] = React.useState(false);
    const [deleteStyle, resultStats] = useDeleteStyleMutation()
    const [successAlert, setSuccessAlert] = React.useState(false);
    const [errorAlert, setErrorAlert] = React.useState(false);


    const handleClickOpen = (id) => {
        setOpen(true);
        setSelectedId(id);
    };

    const handleClose = () => {
        setOpen(false);
    };

    React.useEffect(() => {
        if (resultStats?.isSuccess) {
            setSuccessAlert(true)
            setTimeout(() => {
                setSuccessAlert(false)
            }, 2000);
        }

        if (resultStats?.isError) {
            setErrorAlert(true)
            setTimeout(() => {
                setErrorAlert(false)
            }, 2000);
        }
    }, [resultStats])

    const handleDelete = () => {
        handleClose()
        deleteStyle(selectedId);
        setOpen(false);
    }

    return (
        <>
            {successAlert &&
                <SuccessAlert title="Style has been deleted successfully!" />
            }

            {errorAlert &&
                <ErrorAlert title="Something Went Wrong!" />
            }

            <TableContainer component={Paper}>

                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", py: 2, px: 2 }}>
                    <Typography variant='h6' component={"h6"} flexGrow={1}>
                        Styles
                    </Typography>

                    <AddStyleModal styles={FetchStyles} />
                </Box>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell>Name</TableCell>
                            <TableCell >Description</TableCell>
                            <TableCell align="center">Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {isLoading &&
                            <TableRow>
                                <TableCell colSpan={4}>Loading...</TableCell>
                            </TableRow>
                        }

                        {!isLoading && FetchStyles?.length > 0 ? (FetchStyles?.map((row, index) =>
                        (
                            <TableRow
                                key={index}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                <TableCell >{row.name}</TableCell>
                                <TableCell>
                                    {row.description.length > 30
                                        ? row.description.substr(0, 30) + '...'
                                        : row.description}
                                </TableCell>

                                <TableCell align="center">
                                    <>
                                        <Tooltip title="Delete">
                                            <IconButton onClick={() => handleClickOpen(row._id)} color='primary' >
                                                <DeleteIcon />
                                            </IconButton>
                                        </Tooltip>
                                        <Dialog
                                            maxWidth="sm"
                                            fullWidth
                                            open={open}
                                            aria-labelledby="alert-dialog-title"
                                            aria-describedby="alert-dialog-description"
                                        >
                                            <DialogTitle id="alert-dialog-title">
                                                {"Confirm the Action?"}
                                            </DialogTitle>
                                            <Box position="absolute" top={10} right={0}>
                                                <IconButton onClick={handleClose}>
                                                    <Close />
                                                </IconButton>
                                            </Box>
                                            <DialogContent>
                                                <DialogContentText id="alert-dialog-description">
                                                    Do you really want to delete the style?
                                                </DialogContentText>
                                            </DialogContent>
                                            <DialogActions>
                                                <Button onClick={handleClose} variant="outlined">Cancel</Button>
                                                <Button onClick={() => handleDelete(row._id)} variant="contained" autoFocus>
                                                    Confirm
                                                </Button>
                                            </DialogActions>
                                        </Dialog>
                                    </>
                                    <ViewStyleModal item={row} FetchStyles={FetchStyles} />
                                    <UpdateStyleModal item={row} FetchStyles={FetchStyles} />
                                </TableCell>
                            </TableRow>
                        ))) : !isLoading && FetchStyles?.length === 0 ? (
                            <TableRow>
                                <TableCell colSpan={4}>No Record !</TableCell>
                            </TableRow>
                        ) : null}
                    </TableBody>
                </Table>
            </TableContainer >
        </>
    );

}

